import { Flex } from "@chakra-ui/react";
import {
  useCurrentAccount,
  useGetAccountBalanceDetails,
  useGetAccountDelegate,
} from "@umami/state";
import { BigNumber } from "bignumber.js";

import { EmptyMessage } from "../../components/EmptyMessage";
import { ViewOverlay } from "../../components/ViewOverlay/ViewOverlay";

import { trackButtonClick } from "@/utils/analytics";

export const Earn = () => {
  const currentAccount = useCurrentAccount()!;
  const address = currentAccount.address.pkh;
  const delegate = useGetAccountDelegate()(address);
  const { spendableBalance, totalBalance } = useGetAccountBalanceDetails(address);
  const isBalanceEqualToSpendable = BigNumber(totalBalance).isEqualTo(spendableBalance);

  const stakeTezosUrl = "https://stake.tezos.com/";

  const CtaMessage = ({
    cta,
    subtitle,
    title,
    onClick,
  }: {
    cta: string;
    subtitle: string;
    title: string;
    onClick?: () => void;
  }) => (
    <EmptyMessage
      cta={cta}
      ctaUrl={stakeTezosUrl}
      onClick={onClick}
      subtitle={subtitle}
      title={title}
    />
  );

  const getCtaMessage = () => {
    if (!delegate) {
      return (
        <CtaMessage
          cta="Start earning"
          onClick={() => {
            trackButtonClick("start_earning", {
              button_label: "Start earning",
              section: "dashboard",
              action: "button_click",
              flow: "earn",
            });
          }}
          subtitle="Unlock the potential of your tez. Delegate or stake now and see your rewards grow."
          title="Earn rewards"
        />
      );
    }

    if (isBalanceEqualToSpendable) {
      return (
        <CtaMessage
          cta="Stake"
          onClick={() => {
            trackButtonClick("stake", {
              button_label: "Stake",
              section: "dashboard",
              action: "button_click",
              flow: "earn",
            });
          }}
          subtitle="Maximize your tez with staking.com. Secure, efficient, and simple."
          title="Boost your rewards"
        />
      );
    }

    return (
      <CtaMessage
        cta="Manage funds"
        onClick={() => {
          trackButtonClick("manage_funds", {
            button_label: "Manage funds",
            section: "dashboard",
            action: "button_click",
            flow: "earn",
          });
        }}
        subtitle="Stake, unstake and finalize the unstaked tez using the Tezos staking app."
        title="Manage your funds"
      />
    );
  };

  return (
    <>
      <Flex
        zIndex={1}
        flexGrow={1}
        width="full"
        padding={{
          md: "10px",
          base: "8px",
        }}
      >
        {getCtaMessage()}
      </Flex>
      <ViewOverlay iconType="earn" />
    </>
  );
};
